import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { IssueViewerComponent } from "./components/issue-viewer/issue-viewer.component";

export const routes: Routes = [
  { path: '', component:  IssueViewerComponent }, 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IssueManagerRoutingModule { }
